import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/node_modules/next/dist/client/script.js");
